import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { MeProvider } from "@/context/MeContext";
import { AuthLayout } from "@/pages/AuthLayout";
import { ProtectedApp } from "@/components/layout/ProtectedApp";
import PublicLinkPage from "@/pages/PublicLinkPage";
import { UploadPanel } from "@/components/files/UploadPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={
              <AuthLayout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthLayout>} />
            <Route path="/sign-up/*" element={
              <AuthLayout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthLayout>} />
            <Route path="/s/:token" element={<PublicLinkPage />} />
            <Route path="/*" element={
              <>
                <Show when="signed-in"><MeProvider><ProtectedApp /></MeProvider></Show>
                <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
              </>
            } />
          </Routes>
        </ClerkAuthProvider>
        <Toaster richColors position="bottom-right" />
        <UploadPanel />
      </BrowserRouter>
    </div>
  );
}

export default App;
